import {
  GetEstadoProceso,
  PostCalcularAlcances,
  PostConfirmarAlcances,
  PostPrecalculo,
  PostCalcularComisiones,
  DeleteCalcularAlcances,
  DeleteConfirmarAlcances,
  DeletePrecalculo,
  DeleteCalcularComisiones
} from "../../../reducers/comisionMembresia";
import * as actions from "../../../actions/comisionMembresia";
import { Preview } from "../../../../types/IAction";

export interface ProcesoDispatcher {
  getEstadoProceso: (periodo: string) => Promise<Preview<GetEstadoProceso>>;
  postCalcularAlcances: (
    periodo: string
  ) => Promise<Preview<PostCalcularAlcances>>;
  postConfirmarAlcances: (
    periodo: string
  ) => Promise<Preview<PostConfirmarAlcances>>;
  postPrecalculo: (
    periodo: string,
    tipoProceso: string
  ) => Promise<Preview<PostPrecalculo>>;
  postCalcularComisiones: (
    periodo: string,
    tipoProceso: string
  ) => Promise<Preview<PostCalcularComisiones>>;
  deleteCalcularAlcances: (
    periodo: string
  ) => Promise<Preview<DeleteCalcularAlcances>>;
  deleteConfirmarAlcances: (
    periodo: string
  ) => Promise<Preview<DeleteConfirmarAlcances>>;
  deletePrecalculo: (
    periodo: string,
    tipoProceso: string
  ) => Promise<Preview<DeletePrecalculo>>;
  deleteCalcularComisiones: (
    periodo: string,
    tipoProceso: string
  ) => Promise<Preview<DeleteCalcularComisiones>>;
}

export const procesoDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ProcesoDispatcher = dispatch => ({
  getEstadoProceso: (periodo: string) => {
    return dispatch(actions.getEstadoProceso(periodo));
  },
  postCalcularAlcances: (periodo: string) => {
    return dispatch(actions.postCalcularAlcances(periodo));
  },
  postConfirmarAlcances: (periodo: string) => {
    return dispatch(actions.postConfirmarAlcances(periodo));
  },
  postPrecalculo: (periodo: string, tipoProceso: string) => {
    return dispatch(actions.postPrecalculo(periodo, tipoProceso));
  },
  postCalcularComisiones: (periodo: string, tipoProceso: string) => {
    return dispatch(actions.postCalcularComisiones(periodo, tipoProceso));
  },
  deleteCalcularAlcances: (periodo: string) => {
    return dispatch(actions.deleteCalcularAlcances(periodo));
  },
  deleteConfirmarAlcances: (periodo: string) => {
    return dispatch(actions.deleteConfirmarAlcances(periodo));
  },
  deletePrecalculo: (periodo: string, tipoProceso: string) => {
    return dispatch(actions.deletePrecalculo(periodo, tipoProceso));
  },
  deleteCalcularComisiones: (periodo: string, tipoProceso: string) => {
    return dispatch(actions.deleteCalcularComisiones(periodo, tipoProceso));
  }
});
